App.namespace.wrap('es6.views.room.hint_tooltips', function () {
  const $personalManagerTooltip = $('.js-roompage-tooltip-personal');
  const $personalManagerTooltipTrigger = $('.js-roompage-tooltip-personal-trigger');

  const saveHowTooltip = '.js-roompage-tooltip-save-how';
  const $saveHowTooltipTrigger = $('.js-roompage-tooltip-save-how-trigger');

  const togglePersonalManagerTooltip = () => {
    $personalManagerTooltip.toggle();
  };

  const toggleSaveHowTooltip = () => {
    $(saveHowTooltip).toggleClass('visible');
  };

  const bindEvents = () => {
    $personalManagerTooltipTrigger.hover(togglePersonalManagerTooltip);
    $saveHowTooltipTrigger.hover(toggleSaveHowTooltip);
  };

  const init = () => {
    bindEvents();
  };

  return {
    init,
  }
});
